"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = __importDefault(require("gsap"));
class InfoSlider {
    element;
    slider;
    marker = document.createElement('div');
    resizeHandle = null;
    isResizing = false;
    minWidth = 400;
    maxWidth = 1600;
    defaultWidth = 700;
    currentWidth;
    storageKey = 'infoSliderWidth';
    onOpen = null;
    onClose = null;
    onInit = null;
    constructor({ element, onOpen = null, onClose = null, onInit = null, storageKey = 'infoSliderWidth', }) {
        if (typeof element === 'string') {
            element = document.querySelector(element);
            if (!element) {
                throw new Error('Element not found for info slider');
            }
        }
        this.element = element;
        this.element.classList.add('info-slider-trigger');
        this.slider = this.element.dataset.infoSliderTrigger ? document.querySelector(this.element.dataset.infoSliderTrigger) : null;
        if (!this.slider) {
            throw new Error('Slider not found for info slider');
        }
        this.storageKey = this.element.dataset.infoSliderStorageKey || storageKey;
        const savedWidth = localStorage.getItem(this.storageKey);
        this.currentWidth = savedWidth ? parseInt(savedWidth) : this.defaultWidth;
        const button = document.createElement('button');
        button.classList.add('info-slider-close-internal');
        const icon = document.createElement('span');
        icon.classList.add('icon');
        icon.textContent = 'close';
        button.appendChild(icon);
        button.addEventListener('click', (e) => {
            this.close();
        });
        if (!this.slider.querySelector('.info-slider-close'))
            this.slider.appendChild(button);
        else {
            this.slider.querySelector('.info-slider-close')?.addEventListener('click', (e) => {
                this.close();
            });
        }
        this.createResizeHandle();
        this.slider.remove();
        this.slider.classList.remove('hidden');
        this.element.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.slider?.classList.contains('open')) {
                this.close();
            }
            else {
                this.open();
            }
        });
        if (!this.onInit && this.element.dataset.infoSliderOnInit) {
            const x = this.element.dataset.infoSliderOnInit;
            this.onInit = window[x];
        }
        if (!this.onOpen && this.element.dataset.infoSliderOnOpen) {
            const x = this.element.dataset.infoSliderOnOpen;
            this.onOpen = window[x];
        }
        if (!this.onClose && this.element.dataset.infoSliderOnClose) {
            const x = this.element.dataset.infoSliderOnClose;
            this.onClose = window[x];
        }
        const methods = {
            getSlider: () => this.slider,
            open: this.open.bind(this),
            close: this.close.bind(this),
            onOpen: this.onOpen?.bind(this),
            onClose: this.onClose?.bind(this),
            onInit: this.onInit?.bind(this),
        };
        Object.assign(this.slider, methods);
        Object.assign(this.element, methods);
        this.onInit && this.onInit(this.slider);
    }
    createResizeHandle() {
        if (!this.slider)
            return;
        this.resizeHandle = document.createElement('div');
        this.resizeHandle.classList.add('info-slider-resize-handle');
        this.slider.appendChild(this.resizeHandle);
        this.resizeHandle.addEventListener('mousedown', this.startResize.bind(this));
    }
    startResize(e) {
        e.preventDefault();
        this.isResizing = true;
        document.body.style.cursor = 'ew-resize';
        document.body.style.userSelect = 'none';
        const onMouseMove = (e) => this.handleResize(e);
        const onMouseUp = () => this.stopResize(onMouseMove);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }
    handleResize(e) {
        if (!this.isResizing || !this.slider)
            return;
        const sliderRect = this.slider.getBoundingClientRect();
        const newWidth = sliderRect.right - e.clientX;
        const clampedWidth = Math.max(this.minWidth, Math.min(this.maxWidth, newWidth));
        this.currentWidth = clampedWidth;
        this.slider.style.width = `${clampedWidth}px`;
        localStorage.setItem(this.storageKey, clampedWidth.toString());
    }
    stopResize(onMouseMove) {
        this.isResizing = false;
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
        document.removeEventListener('mousemove', onMouseMove);
    }
    open() {
        document.body.appendChild(this.slider);
        if (this.slider) {
            this.slider.style.width = `${this.currentWidth}px`;
        }
        this.slider?.classList.add('open');
        this.element.classList.add('open');
        this.slider?.querySelector('.info-slider-content')?.classList.add('loading');
        gsap_1.default.fromTo(this.slider, { x: '120%' }, {
            duration: 0.5,
            x: 0,
            ease: 'power2.inOut',
            onComplete: () => {
                this.onOpen && this.onOpen(this.slider);
                this.slider?.querySelector('.info-slider-content')?.classList.remove('loading');
            }
        });
    }
    close() {
        gsap_1.default.to(this.slider, {
            duration: 0.5, x: '120%', ease: 'power2.inOut', onComplete: () => {
                this.onClose && this.onClose(this.slider);
                this.slider?.remove();
                this.slider?.classList.remove('open');
                this.element.classList.remove('open');
            }
        });
    }
}
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-info-slider-trigger]').forEach((el) => {
        new InfoSlider({
            element: el
        });
    });
});
